import { Button, Container, CssBaseline, Divider, Stack, styled } from '@mui/material'
import React from 'react'
import Spec from '../components/Spec'
import { useModel } from '../components/hooks/ModelProvider';
import { NavLink } from 'react-router-dom';
import { red } from '@mui/material/colors';
export default function Page5() {
  const model = useModel();
  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(red[500]),
    textTransform: "capitalize",
    fontFamily: "inherit",
    fontSize: "1.5rem",
    borderRadius: 0,
    backgroundColor: red[500],
    "&:hover": {
      backgroundColor: red[700],
    },
  }));
const interior = [];
const seguridad = [];
  if(model.interior){for (const [, value] of Object.entries( model.interior)) {
 
      interior.push(value?.value)
  
    
  }}
  if(model.seguridad){for (const [, value] of Object.entries( model.seguridad)) {
 
    seguridad.push(value?.value)

  
}}

  return (
    <>
    <div className='resume'>  
    <CssBaseline />
    <Container><Stack sx={{marginBottom: '20px'}}minWidth="100%" direction="row" justifyContent="flex-end">
            <NavLink style={{ justifySelf: "flex-end" }} to="/page4">
            <ColorButton size="small">Regresar</ColorButton>
          </NavLink>
          </Stack>
          </Container>
    <Container sx={{paddingLeft: '50px', paddingRight: "50px"}}>
    <h2 style={{fontWeight: 'normal', margin: '10px 0', fontSize: '1.75rem'}}>Resumen de <span style={{fontWeight: 'bold'}}>tu Configuración</span></h2>
          <Stack sx={{marginTop: "20px"}} flexWrap="wrap" className="resume-sheet" direction="row" justifyContent='flex-start' alignItems='flex-start' gap={5}>
    <Stack 
  divider={<Divider orientation="horizontal" flexItem />}><Spec title="Unidad" spec={ model.model === '680' ? model.nextGen ? "T" + model.model + ' 72"': "T"+ model.model + ' 52"': "T" + model.model}/>
   <Spec title="Motor" spec={ model.engine}/>
   <Spec title="Potencia" spec={ model.potencia ? model.potencia?.value: ''}/>
   <Spec title="Transmisión" spec={ model.potencia ? model.transmission?.value: ''}/>
   <Spec title="Eje delantero" spec={ model.potencia ? model.frontAxle?.value: ''}/>
   <Spec title="Eje trasero" spec={ model.potencia ? model.rearAxle?.value: ''}/>
    <Spec title="Suspensión" spec={ model.potencia ? model.suspension?.value: ''}/></Stack>


    <Stack divider={<Divider orientation="horizontal" flexItem />}>
    <Stack><Spec title="Faro delantero" spec={ model?.exterior?.faroDelantro ? model.exterior.faroDelantro?.value : ''}/></Stack>
    <Stack><Spec title="Faros neblineros en defensa" spec={ model?.exterior?.farosNeblineros? model.exterior.farosNeblineros?.value : ''}/></Stack>
    <Stack><Spec title="Luces traseras" spec={ model?.exterior?.lucesTraseras ? model.exterior.lucesTraseras?.value: ''}/></Stack>
    <Stack><Spec title="Escape" spec={ model?.exterior?.escape ? model.exterior.escape?.value: ''}/></Stack>
    <Stack><Spec title="Llantas" spec={ model?.exterior?.llantas ? model.exterior.llantas?.value: ''}/></Stack>
    <Stack><Spec title="Rines" spec={ model?.exterior?.rines ? model.exterior.rines?.value: ''}/></Stack>
    <Stack><Spec title="Dimensiones" spec={ model?.exterior?.dimensions ? model.exterior.dimensions?.value: ''}/></Stack>
    </Stack>

    <Stack direction='row' flexWrap='wrap' gap={5}>
    <Stack divider={<Divider orientation="horizontal" flexItem />}>
    <Spec title="Interior" spec={ model.interior ? <Stack divider={<Divider orientation="horizontal" flexItem />}>{interior.map((e, index)=>{
      return <div key={index}>{e}</div>
    })}</Stack>: ''}/>
    <Spec title="Cinturón" spec={ model.cinturon? model.cinturon?.value: ''}/>
    <Spec title="Seguridad" spec={ model.seguridad ? <Stack divider={<Divider orientation="horizontal" flexItem />}>{seguridad.map((e, index)=>{
      return <div key={index}>{e}</div>
    })}</Stack>: ''}/>
    <Spec title="Capacidad" spec={ model?.capacidad ? model.capacidad?.value: ''}/>
    </Stack>
    <Stack divider={<Divider orientation="horizontal" flexItem />}>
    <Spec title="Asientos y acabados" spec={ model?.asientosYacabados ? model.asientosYacabados?.value: ''}/>
    <Spec title="Color de la Unidad" spec={ model.color ? model.color: ''}/>
    </Stack>
    </Stack>
    </Stack>
    <h2 style={{fontWeight: 'normal', margin: '30px 0 10px 0', fontSize: '1.75rem'}}>Datos de <span style={{fontWeight: 'bold'}}>Contacto</span></h2>
    <Stack>
    <div>{model?.contact?.name}</div>
    <div>{model?.contact?.email}</div>
    <div>{model?.contact?.phone}</div>
    <div>{model?.contact?.address}</div>
    <div>{model?.contact?.city}</div>
    <div>{model?.contact?.business}</div>
    </Stack>
      
    <Stack sx={{marginTop: '20px', marginBottom: '20px'}} direction="row" justifyContent={{xs: "center", sm:"flex-end"}}>
                <ColorButton form='contact-form'type='submit'size="sm">Contacta a un Asesor</ColorButton>
        </Stack>
    </Container>
  
    </div>
    </>
  )
}
